import { Tooltip } from "@components/tooltip/tooltip";
import TopicflowIcon from "@components/topicflow-icon/topicflow-icon";
import { classNames } from "@helpers/css";

const SidebarHijack = ({ menuIsCollapsed }: { menuIsCollapsed?: boolean }) => {
  if (!window.hijackedUser) {
    return null;
  }

  return (
    <div className="text-sm border-r w-full bg-blue-100">
      <form action={window.hijackedUser.release_url} method="POST">
        <input
          type="hidden"
          name="csrfmiddlewaretoken"
          value={window.TF.csrf}
        />
        <input type="hidden" name="next" value={window.hijackedUser.next_url} />

        <div className="flex items-center">
          {!menuIsCollapsed && (
            <div className="p-2 text-gray-600 flex-1 min-w-0">
              <div className="break-words">
                Logged in as:{" "}
                <span className="font-medium">
                  {window.hijackedUser.user.name}
                </span>
              </div>
              <div className="text-xs italic text-gray-500 break-words">
                {window.hijackedUser.user.email} (pk:{" "}
                {window.hijackedUser.user.id})
              </div>
            </div>
          )}

          <button
            type="submit"
            className={classNames(
              "p-2 self-stretch cursor-pointer text-gray-600 hover:bg-gray-100 hover:text-gray-700 shrink-0",
              menuIsCollapsed && "flex-1 flex justify-center",
            )}
          >
            <Tooltip text={`Release ${window.hijackedUser.user.name}`}>
              <span>
                <TopicflowIcon type="exit" className="h-5 w-5" />
              </span>
            </Tooltip>
          </button>
        </div>
      </form>
    </div>
  );
};
export default SidebarHijack;
